export const SET_NEXT_RESUME_RESULT_ITEM = 'SET_NEXT_RESUME_RESULT_ITEM';

export const setNextResumeResultItem = (resultId, nextItem) => ({
    type: SET_NEXT_RESUME_RESULT_ITEM,
    resultId,
    nextItem,
});
